export function reportError(code, message, error) {
  if (__DEV__) {
    console.log(code, message, error);
  }
  if (__CLIENT__) {
    try {
      const doc = global.document;
      const img = doc.createElement('img');
      img.src =
        '/i.gif?error=' +
        encodeURIComponent(JSON.stringify({ code, message, error }));
      doc.getElementsByTagName('body')[0].appendChild(img);
    } catch (err) {
      if (__DEV__) {
        console.error(err);
      }
    }
  }
}
